<template>
  <v-table
      :count="count"
      :list="list"
      :query-list="queryList"
      :is-loading="isLoading"
      :push-list="pushStudentList"
      :is-show-store-select="true"
      :is-store-select-clearable="true"
      :has-private-store="true"
      :is-show-search-input="true"
  >
    <v-column-time value="注册时间" align="center"/>

    <v-column-student align="center"/>

    <el-table-column label="ID" prop="id" align="center"/>

    <el-table-column label="手机号" prop="phone" align="center"/>

    <el-table-column label="注册来源" align="center">
      <template v-slot="{ row }">{{ row.store_name || '小程序' }}</template>
    </el-table-column>

    <el-table-column label="会员卡号" prop="card_number" align="center"/>

    <el-table-column label="拥有课卡数量" prop="card_count" align="center"/>

    <el-table-column label="账号状态" align="center">
      <template v-slot="{ row }">
        <span class="danger-color" v-if="row.is_archive" >账号状态异常，学员信息需要核实并更新，请联系总部管理员</span>
        <span class="success-color" v-else>正常</span>
      </template>
    </el-table-column>

    <el-table-column label="操作" :width="`${ isAdministrator ? '300px' : '244px'}`" align="center">
      <template v-slot="{ row }">
        <v-list-button :to="studentEditTo(row.id)"/>
        <v-list-button name="注销" icon="bin" :to="studentDeleteDetailTo(row.id)"/>
        <template v-if="isAdministrator">
          <v-popover v-if="row.is_archive">
            <v-popover-item
              icon="restore"
              name="恢复正常"
              @click="handleRestore(row)"
              :is-loading="isRestoring[row.id]"
              message="确认要将该学员从异常状态恢复为正常吗？"
            />
          </v-popover>
          <v-popover v-else>
            <v-popover-item
              icon="bin"
              name="设为异常"
              @click="handleArchive(row)"
              :is-loading="isRestoring[row.id]"
              message="设为异常后该账号将无法进行预约，确认要将该账号设置为异常状态吗？"
            />
          </v-popover>
        </template>

      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>姓名</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>注册时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>注册来源</span>
              <span>{{ v.store_name || '小程序' }}</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>

            <div class="list-item-detail">
              <span>会员卡号</span>
              <span>{{ v.card_number }}</span>
            </div>

            <div class="list-item-detail">
              <span>拥有课卡数量</span>
              <span>{{ v.card_count }}</span>
            </div>

            <div class="list-item-detail">
              <span class="flex-shrink">账号状态</span>
              <span class="list-item-info danger-color" v-if="v.is_archive" >账号状态异常，学员信息需要核实并更新，请联系总部管理员</span>
              <span class="list-item-info success-color" v-else>正常</span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="studentEditTo(v.id)"/>

              <v-list-button
                name="注销"
                icon="bin"
                :to="studentDeleteDetailTo(v.id)"
              />

              <template v-if="isAdministrator">
                <v-popover v-if="v.is_archive">
                  <v-popover-item
                    icon="restore"
                    name="恢复正常"
                    @click="handleRestore(v)"
                    :is-loading="isRestoring[v.id]"
                    message="确认要将该学员从异常状态恢复为正常吗？"
                  />
                </v-popover>
                <v-popover v-else>
                  <v-popover-item
                    icon="bin"
                    name="设为异常"
                    @click="handleArchive(v)"
                    :is-loading="isRestoring[v.id]"
                    message="设为异常后该账号将无法进行预约，确认要将该账号设置为异常状态吗？"
                  />
                </v-popover>
              </template>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>

  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, setArchive, cancelArchive } from '@/api/student';

export default {
  name: RouteConfig.studentList.name,
  data: () => ({
    RouteConfig,
    pushStudentList: RouteConfig.studentList.push,
    studentEditTo: RouteConfig.studentEdit.to,
    studentDeleteDetailTo: RouteConfig.studentDeleteDetail.to,
    isLoading: false,
    isShowDialog: false,
    isSavingIds: [],
    isSettingIds: [],
    isDeleting: {},
    isRestoring: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
      is_has_card: 1,
    },
    currentStudentId: 0,
    actual_payment: 0,
    not_consumed_amount: 0,
    teacher: {
      teacher_id: 0,
    },
    rules: {
      teacher_id: [{ required: true, message: '请选择老师', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isMobile',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      this.pushStudentList(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      queryList.is_has_card = 1;
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    async handleArchive({ id, update_time }) {
      if (!id) return this.$message.warning('缺少学员 ID，无法设置！');
      if (this.isRestoring[id]) return;

      this.$set(this.isRestoring, id, true);
      const { isError } = await setArchive(id, { update_time });
      this.$set(this.isRestoring, id, false);
      if (!isError) this.load();
    },
    async handleRestore({ id, update_time }) {
      if (!id) return this.$message.warning('缺少学员 ID，无法恢复该学员！');
      if (this.isRestoring[id]) return;

      this.$set(this.isRestoring, id, true);
      const { isError } = await cancelArchive(id, { update_time });
      this.$set(this.isRestoring, id, false);
      if (!isError) this.load();
    },
  },
};
</script>

<style src="./index.css" scoped/>
